import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyPost } from "../../redux/post/postAction";

import Post, { ViewPost } from "../Post";
import { AnimatePresence, LayoutGroup, motion } from "framer-motion";
import ClickOutsideWrapper from "../ModalComponents/ClickOutsideWrapper";
import { FeedLoader } from "../SkeletonLoaders";
import { EmptyPostList } from "../EmptyUI";

const MyPost = () => {
  const dispatch = useDispatch()
  const { userData } = useSelector((state) => state.user)
  const { myPost, myPostLoading } = useSelector((state) => state.post)
  const [viewedPost, setViewPost] = useState(null)

  useEffect(() => {
    if (userData && userData.userId && myPost?.length === 0) {
      dispatch(getMyPost(userData.userId))
    }
  }, [userData, myPost?.length, dispatch])

  const handleViewPost = useCallback((post) => {
    setViewPost(post)
  }, [])


  return (
    <LayoutGroup>
      <div className="w-full">
        <div className="my-4 grid grid-cols-1 gap-6">
          {myPost && myPost?.length > 0 &&
            myPost?.map((feed, index) => (
              <Post key={feed.postId} feed={feed} viewPost={handleViewPost} />
            ))
          }
          {myPostLoading && myPost?.length === 0 &&
            <FeedLoader />
          }

          {!myPostLoading && myPost?.length === 0 &&
            <div className="w-full p-4 rounded-2xl bg-customGray">
              <EmptyPostList />
            </div>
          }
        </div>

        <AnimatePresence>
          {viewedPost &&
            <motion.div className="fixed inset-0 z-50 h-screen py-10 flex flex-col items-center justify-center ">
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }} className="absolute inset-0 " />
              <ClickOutsideWrapper onClose={() => setViewPost(null)} className="lg:w-[50%] sm:w-full h-full">
                <ViewPost feed={viewedPost} />
              </ClickOutsideWrapper>
            </motion.div>
          }
        </AnimatePresence>
      </div>
    </LayoutGroup>
  );
};

export default MyPost;

